import { render, staticRenderFns } from "./dialA06.vue?vue&type=template&id=27aafed4&"
import script from "./dialA06.vue?vue&type=script&lang=js&"
export * from "./dialA06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialA06.vue"
export default component.exports